import { SystemUser } from 'types';
import { baseQuery } from '../baseQuery';

export const getDiscountApprovers = async () => {
  const { data } = await baseQuery('discounts-approved-by-users');

  return data as SystemUser[];
};
